import { Button } from '@/components/ui/Button'
import { Icon } from '@/components/ui/Icon'
import { Modal } from '@/components/ui/Modal'
import { formatPhone } from '@/lib/phone'
import { useState } from 'react'

interface CallDonorButtonProps {
  phone?: string
  variant?: 'light' | 'primary' | 'default'
  /** Icon-only round button for collapsed state */
  iconOnly?: boolean
  className?: string
}

export const CallDonorButton = ({
  phone,
  variant = 'light',
  iconOnly = false,
  className,
}: CallDonorButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClick = () => {
    if (phone) {
      setIsModalOpen(true)
    }
  }

  const handleConfirm = () => {
    if (phone) {
      window.open(`tel:${phone}`, '_self')
      setIsModalOpen(false)
    }
  }

  return (
    <>
      {iconOnly ? (
        <Button
          icon={<Icon name="phone" />}
          variant={variant}
          rounded
          onClick={handleClick}
          className={className}
          testId="call-donor-button-icon"
        />
      ) : (
        <Button
          text="Call Donor"
          icon={<Icon name="phone" size={16} />}
          iconPosition="left"
          variant={variant}
          onClick={handleClick}
          className={className}
          testId="call-donor-button"
        />
      )}

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Do you want to call the donor?"
        buttonLayout="column"
        testId="call-donor-modal"
        buttons={[
          <Button
            key="call"
            text={`Call donor ${formatPhone(phone, '')}`}
            variant="primary"
            icon={<Icon name="phone" size={16} />}
            onClick={handleConfirm}
            testId="call-donor-modal-confirm"
          />,
          <Button
            key="back"
            text="Go back"
            variant="default"
            onClick={() => setIsModalOpen(false)}
            testId="call-donor-modal-back"
          />,
        ]}
      />
    </>
  )
}
